module.exports = __webpack_public_path__ + "img/logo-altera-2021 2.e45eb623.svg";